import { isIOS } from './device';
export var BrowserName;
(function (BrowserName) {
    BrowserName["FIREFOX"] = "Firefox";
    BrowserName["OPERA"] = "Opera";
    BrowserName["IE"] = "Internet Explorer";
    BrowserName["EDGE"] = "Edge";
    BrowserName["CHROME"] = "Chrome";
    BrowserName["SAFARI"] = "Safari";
    BrowserName["UNKNOWN"] = "UNKNOWN";
})(BrowserName || (BrowserName = {}));
export const getBrowserName = () => {
    try {
        const userAgent = navigator.userAgent;
        let browser = BrowserName.UNKNOWN;
        // the order of checks is important, userAgent usually contains more then one browser name
        if (userAgent.indexOf(BrowserName.FIREFOX) > -1 || !!window.mozInnerScreenX) {
            browser = BrowserName.FIREFOX;
        }
        else if (userAgent.indexOf(BrowserName.OPERA) > -1 || userAgent.indexOf('OPR') > -1) {
            browser = BrowserName.OPERA;
        }
        else if (userAgent.indexOf('Trident') > -1) {
            browser = BrowserName.IE;
        }
        else if (userAgent.indexOf(BrowserName.EDGE) > -1) {
            browser = BrowserName.EDGE;
        }
        else if (userAgent.indexOf(BrowserName.CHROME) > -1 || userAgent.indexOf('CriOS') > -1) {
            browser = BrowserName.CHROME;
        }
        else if (userAgent.indexOf(BrowserName.SAFARI) > -1) {
            browser = BrowserName.SAFARI;
        }
        return browser;
    }
    catch (e) {
        return BrowserName.UNKNOWN;
    }
};
export const isSafari = () => {
    return getBrowserName() === BrowserName.SAFARI;
};
export const isIE = () => {
    return getBrowserName() === BrowserName.IE;
};
export const isSafariBrowserOfiOS = () => isSafari() && isIOS();
export const isClient = () => typeof window !== 'undefined';
//# sourceMappingURL=browser.js.map